var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRealm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110 90",
    style: {
      enableBackground: "new 0 0 110 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FCC397;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FC9F95;}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#F77C88;}\r\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#F25192;}\r\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#D34CA3;}\r\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#9A50A5;}\r\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#59569E;}\r\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:#39477F;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RealM"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.7,22.4c-9.3-4.4-20.4-2.6-27.9,4.5C33,31.4,74.2,26.4,65.7,22.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.5,29.4c0,0-2,2.9-8.3,3.6c-12.5,1.6-34.1,1.8-34,1.7c1.3-2.9,3.2-5.5,5.5-7.7c2.7,0.9,5.6,1,8.4,0.5 c4.6-0.8,8.7-3.5,13.2-4.6c2-0.5,4.2-0.6,6.3-0.5C69.1,24,72.1,26.4,74.5,29.4L74.5,29.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M79.7,41.1c0,0.1-28.3,2.8-42.1,2c-2.7-0.1-5.2-1.2-7.1-3.1c0.4-1.8,0.9-3.6,1.7-5.3c4-2.2,8.6-3.4,13.2-3.4 c5.7,0,11.3,2,17,1.8c4.3-0.1,8.5-1.4,12.1-3.7C77.2,32.8,79,36.8,79.7,41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M79.9,45v0.4C74,46.7,68,47.4,62,47.3c-10.7-0.3-21.4-1.1-32-2.5c0-1.6,0.2-3.2,0.5-4.8 c3.4,2.1,7.5,3.1,11.5,2.7c3.1-0.5,6.2-1.4,9.1-2.8c2.9-1.4,5.8-2.5,8.9-3.3c4.6-1,9.4-0.7,13.7,1c2.2,0.9,4.2,2,6,3.5 C79.9,42.4,80,43.7,79.9,45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M51.6,53.1c-7.5,1.4-20.4-0.2-20.4-0.3C30.4,50.3,30,47.6,30,45v-0.2c1.2-0.9,2.4-1.7,3.8-2.3 c3.2-1.6,6.8-2.2,10.4-1.9c3.5,0.5,6.9,1.5,10.1,3.1c2.7,1.3,5.5,2.4,8.3,3.3C62.8,47,59.9,51.6,51.6,53.1L51.6,53.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M79.1,51.7c-0.5,0.9-5.5,3.9-12.3,4.4c-8.9,0.7-19.5-2-16-3.4c5.5-2.2,10.3-6.1,16-7.7 c4.3-1.2,8.9-1,13.2,0.4C80,47.5,79.7,49.6,79.1,51.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M76.7,57.5c-4.3,7.5-35.7,9.4-40.2,4.3c-2.3-2.6-4.1-5.6-5.2-8.9c3.8-2.2,8.3-3.1,12.7-2.5 c5.6,0.8,10.6,3.9,16.1,5.1c4.5,1,9.2,0.7,13.5-0.9c2-0.7,3.8-1.7,5.6-2.9C78.6,53.7,77.7,55.6,76.7,57.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M76.7,57.4c-6.9,12-22.1,16.2-34.1,9.3c-2.3-1.3-4.3-3-6.1-4.9c0.8,0.3,1.6,0.5,2.4,0.8 c4.4,1.2,9,1.2,13.4-0.1c2.8-0.8,5.4-2.1,8.1-3.1C65.6,57.5,71.2,56.8,76.7,57.4z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealm);
export default __webpack_public_path__ + "static/media/Realm.321b2319dd16f136fe3f4d8e36d67465.svg";
export { ForwardRef as ReactComponent };